import React from "react";
import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Modal, Button } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import ExportFeildCheckbox from "./ExportFeildCheckbox";
import { exportOredersFunc } from "../../../store/custom-actions/orders-actions/ExportOredersSlicer";
import { exportOrders } from "../../../store/custom-actions/orders-actions/ordersSlicer";

export default function ExportFieldsModal({
    show,
    arrayWhichSelected,
    setShowExportFeilds,
    loading,
}) {
    const { t } = useTranslation();
    const dispatch = useDispatch();

    const [feildsArrayWhichSelected, setFeildsArrayWhichSelected] = useState([]);
    const exportFeilds = [
        { title: "User", name: "user" },
        { title: "Phone", name: "phone" },
        { title: "Status", name: "status" },
        { title: "Address", name: "address" },
        { title: "Invoice Number", name: "invoice_no" },
        { title: "Total Price", name: "total_price" },
        { title: "Payment Status", name: "payment_status" },
        { title: "Payment Gateway", name: "payment_gateway" },
    ];
    const handleCheckFeild = (name) => setFeildsArrayWhichSelected((prev) => [...prev, name]);
    const handleUnCheckFeild = (name) => setFeildsArrayWhichSelected((prev) => prev.filter((item) => item !== name));
    const handleSelectAllFeilds = (e) => {
        if (e.target.checked) {
            setFeildsArrayWhichSelected(exportFeilds.map((item) => item.name));
        } else {
            setFeildsArrayWhichSelected([]);
        }
    };
    const hideExportFeilds = () => {
        setFeildsArrayWhichSelected([]);
        setShowExportFeilds(false);
    };

    const handleExportOrders = async () => {
        dispatch(exportOrders({ ids: arrayWhichSelected, fields: feildsArrayWhichSelected }))
            .then((result) => {
                if (result.payload) {
                    const contentType = result.payload.type || "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
                    const blob = new Blob([result.payload], { type: contentType });
                    const url = URL.createObjectURL(blob);
                    const link = document.createElement("a");
                    link.href = url;
                    link.setAttribute("download", `orders.xlsx`);
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                    URL.revokeObjectURL(url);
                }
            });
    };
    return (
        <Modal show={show} onHide={hideExportFeilds}>
            <Modal.Header closeButton>
                <Modal.Title>{t("Export Feilds")}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className="row">
                    <div className="col-sm-12 col-md-3 flex items-cente">
                        <input
                            type="checkbox"
                            id="all-feilds"
                            className="scale-110 cursor-pointer translate-y-[-1px]"
                            onChange={handleSelectAllFeilds}
                        />
                        <label htmlFor="all-feilds" className="mx-1 cursor-pointer">
                            {t("All")}
                        </label>
                    </div>
                    {exportFeilds?.map((item, index) => (
                        <ExportFeildCheckbox
                            key={index}
                            item={item}
                            arrayWhichSelected={feildsArrayWhichSelected}
                            handlePush={handleCheckFeild}
                            handleDelete={handleUnCheckFeild}
                        />
                    ))}
                </div>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={hideExportFeilds}>
                    {t("Close")}
                </Button>
                <Button variant="primary" onClick={() => {
                    handleExportOrders();
                    hideExportFeilds();
                }}>
                    {loading ? t("Loading") : t("Export")}
                </Button>
            </Modal.Footer>
        </Modal>
    );
}
